import { FormSection } from '@/api/rest/connectionApplication/useGetConnectionApplicationSchema';
import { get as _get } from 'lodash-es';
import { FC } from 'react';
import FieldSet from './FieldSet';
import FieldSetArrayInnerCard from './FieldSetArrayInnerCard';
import FieldSetArrayOuterCard from './FieldSetArrayOuterCard';

const FieldSetArrayReadonly: FC<{
  schemaSection: FormSection;
  definitions: Record<string, any>;
  fieldKey: string;
  formData: any;
}> = ({ definitions, schemaSection, fieldKey: key, formData }) => {
  const submittedValues = _get(formData, key, []);

  return (
    <FieldSetArrayOuterCard>
      {submittedValues.map((_value: unknown, index: number) => (
        <FieldSetArrayInnerCard key={index}>
          {schemaSection.items.type === 'object' && (
            <FieldSet
              namespace={`${key}.${index}`}
              formSection={schemaSection.items}
              definitions={definitions}
              readonly={true}
              formData={formData}
            />
          )}
        </FieldSetArrayInnerCard>
      ))}
    </FieldSetArrayOuterCard>
  );
};

export default FieldSetArrayReadonly;
